export const V3IconProfileViewText = () => <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 8L10 8" stroke="#ABB0BA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2 4L14 4" stroke="#ABB0BA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M2 12L10 12" stroke="#ABB0BA" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
</svg>